import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { DisplayDocumentCore } from '@/components/DisplayDocumentCore/DisplayDocumentCore'
import { EASYSIGN_SERVICE_PATH } from '@/constants/apiUrl'

export const EasySignDocumentPage = observer(() => {
  const store = useContext(StoreContext)
  const { easySignDocumentPage: trans, easySignSignaturePage: transSignature } =
    store.TranslationsState.translations

  return (
    <DisplayDocumentCore
      transOverwrite={{ ...trans, transSignature: transSignature }}
      service={EASYSIGN_SERVICE_PATH}
    />
  )
})
